<template>
  <div :class="classes">
  <el-menu class="el-menu-vertical-demo"  @open="handleOpen"  @close="handleClose"  :unique-opened="true" >
    <template v-for="(item,index) in config">
        <pt-menu-tree-item :data="item"  :index="String(index + 1)" :key="item.action?item.action:index" ref="pt-menu-tree-item"></pt-menu-tree-item>
    </template>
  </el-menu>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-menu-tree'
export default {
  name: 'wt-menu-tree',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    config: {
      type: [Array, String, Boolean],
      required: true
    },
    defaultActive: {
      // 默认路由
      type: [Number, String],
      default: '/'
    },
    collapse: {
      type: Boolean,
      default: false
    },
    isAdd: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    },
    activeTextColor: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleOpen () {

    },
    handleClose () {}
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-menu-tree{
        background-color:rgba(255,255,255,0);
        color:#fff;
        z-index: 10;
        overflow-y: hidden;
    .el-menu-vertical-demo{
        z-index: 10;
        border:none;
        overflow-y: hidden;
        background-color:rgba(255,255,255,0);
        color:#fff;
    }
}
</style>
